export default __webpack_public_path__ + "67eb440b9fa8d6c6f70fa41b38bbac2f.svg";